module.exports = __webpack_public_path__ + "img/9.cf8ecb4d.png";